import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { ImagePreviewButtonComponent } from '@aipb/gulliver/catalog/feature-image-preview';
import { MultiImageDownloadCheckboxComponent } from '@aipb/gulliver/catalog/feature-multi-image-download';
import { CatalogRecHeader, CustomRecordItem } from "@aipb/gulliver/catalog/model";
import { NibbleTypeIconComponent } from '@aipb/gulliver/personal-content/ui';

import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

@Component({
  selector: 'cat-header-image',
  templateUrl: './header-image.component.html',
  styleUrls: ['./header-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NibbleTypeIconComponent, MultiImageDownloadCheckboxComponent, ImagePreviewButtonComponent]
})
export class HeaderImageComponent {
  @Input() item: CustomRecordItem;
  @Input() coreId: string;
  @Input() imageUrl: string;

  private catalogEnv = inject(CatalogEnvService);
  imageHeight = this.catalogEnv.env.castorHeaderImageHeight;

  private _header: CatalogRecHeader;

  get header() {
    return this._header;
  }

  @Input() set header(value: CatalogRecHeader) {
    this._header = value;
  }

  get id(): string {
    return this.item[this.catalogEnv.env.castor.UUID];
  }

  get showHeaderImageIcon(): boolean {
    return this.catalogEnv.env.showHeaderImageIcon;
  }
}
